type IconProps = React.HTMLAttributes<SVGElement>;

export const PlusIcon = (props: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="12" fill="currentColor" />
    <line x1="12" y1="5" x2="12" y2="19" stroke="white" strokeWidth="2" />
    <line x1="19" y1="12" x2="5" y2="12" stroke="white" strokeWidth="2" />
  </svg>
);
